import { render, staticRenderFns } from "./CodeVerificationInterface.vue?vue&type=template&id=5115a68f&scoped=true&"
import script from "./CodeVerificationInterface.vue?vue&type=script&lang=js&"
export * from "./CodeVerificationInterface.vue?vue&type=script&lang=js&"
import style0 from "./CodeVerificationInterface.vue?vue&type=style&index=0&id=5115a68f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5115a68f",
  null
  
)

export default component.exports